export enum SUPPORTS_TABS {
  CONTACT = 'contact',
  HELP_CENTER = 'help_center',
}
